import { Amplify } from "aws-amplify";
import {
  confirmResetPassword,
  confirmSignIn,
  fetchAuthSession,
  getCurrentUser,
  resetPassword,
  signIn,
  signInWithRedirect,
  signOut,
  signUp,
  updatePassword,
} from "aws-amplify/auth";

import getAmplifyConfig from "~/amplify.config";
import type { AuthProvider } from "~/types/Auth";

export type AmplifyAuthProvide = {
  /**
   * Auth methods provided by Amplify
   * See: https://docs.amplify.aws/vue/build-a-backend/auth/connect-your-frontend/
   */
  auth: {
    getCurrentUser: typeof getCurrentUser;
    signIn: typeof signIn;
    confirmSignIn: typeof confirmSignIn;
    signUp: typeof signUp;
    signOut: typeof signOut;
    signInWithRedirect: typeof signInWithRedirect;
    fetchAuthSession: typeof fetchAuthSession;
    resetPassword: typeof resetPassword;
    confirmResetPassword: typeof confirmResetPassword;
    updatePassword: typeof updatePassword;
  };
  setCustomProviders: (customProviders: AuthProvider[]) => void;
};

export default defineNuxtPlugin<{ amplify: AmplifyAuthProvide | undefined }>({
  name: "amplify",
  dependsOn: ["platform"],
  enforce: "pre",
  setup: async () => {
    if (import.meta.server) {
      return {
        provide: {
          amplify: undefined,
        },
      };
    }

    const config = useRuntimeConfig();

    const setCustomProviders = (customProviders: AuthProvider[]) => {
      const amplifyConfig = getAmplifyConfig(config, customProviders);
      Amplify.configure(amplifyConfig, { ssr: false });
    };

    const amplifyConfig = getAmplifyConfig(config, []);
    Amplify.configure(amplifyConfig, { ssr: false });

    return {
      provide: {
        amplify: {
          auth: {
            signIn,
            confirmSignIn,
            signUp,
            signOut,
            signInWithRedirect,
            getCurrentUser,
            fetchAuthSession,
            resetPassword,
            confirmResetPassword,
            updatePassword,
          },
          setCustomProviders,
        },
      },
    };
  },
});
